module.exports = __webpack_public_path__ + "img/oil-harbour.cc20ace7.webp";